import { SUPPORTED_IMAGE_FILES, SUPPORTED_VIDEO_FILES, SupportedFileType } from './constants';

const videoFilesLowerCase = SUPPORTED_VIDEO_FILES.map((val) => val.toLowerCase());
const imageFilesLowerCase = SUPPORTED_IMAGE_FILES.map((val) => val.toLowerCase());

// if file type is not supported return undefined
export function getSupportedFileType({ type, name }: File): SupportedFileType | undefined {
  const mimeType = type.toLowerCase();
  const subtype = name.slice(name.lastIndexOf('.') + 1).toLowerCase(); // mov, qt, avi, png etc.

  if (mimeType.startsWith('video/') && videoFilesLowerCase.includes(subtype)) {
    return SupportedFileType.Video;
  }

  if (mimeType.startsWith('image/') && imageFilesLowerCase.includes(subtype)) {
    return mimeType === 'image/gif' ? SupportedFileType.Gif : SupportedFileType.Image;
  }

  return undefined;
}
